import * as React from 'react';
import styled from 'styled-components';
import { Slide } from 'react-reveal';

import { Button, LinkChevron, BREAK_POINTS } from '@origin-digital/style-guide';
import { WarningIcon } from '@origin-digital/icon';

import { IWizardStepProps, WizardContext } from '../../Wizard';
import {
  FixedErrorContainer,
  ErrorContainer,
  ContinueContainer,
  ActionsContainer,
} from './Actions.styles';

export class Continue extends React.Component<IWizardStepProps, {}> {
  public state = { showErrors: false };
  public static contextType = WizardContext;

  handleNext = () => {
    this.props
      .nextStep()
      .then(() => {
        this.setState({ showErrors: false });
      })
      .catch((object) => {
        this.setState({ showErrors: true });
      });
  };

  render() {
    const { showErrors } = this.state;
    const { currentStep, totalSteps } = this.props;

    if (currentStep === totalSteps) {
      return null;
    }
    const { errors } = this.context;
    return (
      <>
        {showErrors && errors.length > 0 && (
          <FixedErrorContainer>
            <Slide top duration={400}>
              <ErrorContainer>
                <div>
                  <WarningIcon size={24} color="red" />
                  {errors.join(' ')}
                </div>
              </ErrorContainer>
            </Slide>
          </FixedErrorContainer>
        )}
        <ContinueContainer>
          <Button
            color="red"
            text="Continue"
            onClick={this.handleNext}
            data-id="wizard:continue-button"
          />
        </ContinueContainer>
      </>
    );
  }
}

export const GoBack = ({ previousStep, currentStep }: IWizardStepProps) => {
  if (currentStep === 1) {
    return null;
  }

  return (
    <LinkChevron
      color="red"
      onClick={previousStep}
      text="Go back a step"
      direction="left"
      href="#"
    />
  );
};

export const StartOver = ({ goToStep }: IWizardStepProps) => {
  return (
    <LinkChevron
      color="red"
      onClick={() => goToStep(1)}
      text="Do the quiz again!"
      direction="left"
      href="#"
    />
  );
};

export const Actions = (props: IWizardStepProps) => (
  <ActionsContainer>
    <Continue {...props} />
    <GoBack {...props} />
  </ActionsContainer>
);
